module.exports = __webpack_public_path__ + "img/bookshelf12.2499bcd1.jpg";